export default {
  name: 'Preview',
  path: '/preview',
  meta: {
    title: 'preview'
  }
};
